(ns common.resource.query.script
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn- transform-scripts [^js data]
  (->> (->clj data)
       (map (fn [s]
              (assoc s :disabled (or (:disabled s) false))))))

(defn scripts-query [{:keys [advertiser-id]}]
  #js {:queryKey #js ["scripts" advertiser-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/advertiser-pixels {:advertiser-id advertiser-id})))
       :select transform-scripts
       :enabled (some? advertiser-id)})

(defn patch-script-mutation [{:keys [advertiser-id pixel-id]}]
  #js {:mutationKey #js ["script" advertiser-id pixel-id]
       :mutationFn (fn [payload]
                     (qhttp/patch (qhttp/render :api/advertiser-pixel {:advertiser-id advertiser-id
                                                                       :pixel-id pixel-id})
                                  {:body payload}))
       :onMutate (fn []
                   (rf/dispatch [:loader/open]))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn [_]
                    (invalidate-queries {:queryKey ["scripts" advertiser-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "script"
                                   :type :success
                                   :message "Successfully saved script"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "script"
                                 :type :error
                                 :message "Failed to save script"
                                 :response (->clj (:data error))}]))})
